// 工单状态处理
import {
  WO_STATUS_TO_BE_ASSIGNED,
  WO_STATUS_TO_BE_CONSTRUCTED,
  WO_STATUS_COMPLETED
} from "@/config/common";

// 工单是否是待确认状态
export const isWorkOrderToBeConfirmed = (woData) => {
    return woData.status == WO_STATUS_TO_BE_ASSIGNED && woData.service_company && (woData.main_engineer || woData.assist_engineer)
}
// 工单是否是待转派状态
export const isWorkOrderToBeReassigned = (woData) => {
    return woData.status == WO_STATUS_TO_BE_ASSIGNED && woData.is_reassign && !woData.main_engineer && !woData.assist_engineer
}
// 工单是否是施工中状态
export const isWorkOrderUnderConstruction = (woData) => {
    return woData.status == WO_STATUS_TO_BE_CONSTRUCTED && woData.is_checkin
}
//工单是否是待施工
export const isWorkOrderToBeConstruction = (woData) => {
    return woData.status == WO_STATUS_TO_BE_CONSTRUCTED && !woData.is_checkin && woData.is_confirm
}
//工单是否是待签字
export const isWorkOrderAwaitingSignature = (woData) => {
    return woData.status == WO_STATUS_COMPLETED  && !woData.is_rating
}
//工单是否是已完成
export const isWorkOrderCompleted = (woData) => {
    return woData.status == WO_STATUS_COMPLETED  && woData.is_rating
}
